module.exports = __webpack_public_path__ + "files/4b01aeac43e97cb057d72f8d40c1d2b4.png";